import instance from "./axios.config";

const getModulesforUser = (eventName) =>
  instance.get(`/inspection/viewModule-events/${eventName}`);

const getEventsByReport = (report_id) =>
  instance.get(`/inspection/geteventsbyreports/${report_id}`);


const insertInspectionReport = (payload) => {
  instance.post("/inspection/create-inspection-report", payload)
}

const getAllinspectionTimestamp = (report) => instance.get(`/inspection/forms/getalluserdatalist/${report}`)

const updateFormConfiguration = (payload) => {
  instance.put("/ships/updateFormConfiguration", payload)
}

const getshipById = (id) => instance.get(`/ships/${id}`)


const getshipspecificformConfiguration = (payload = "") => instance.get(`/ships/getshipspecificformConfiguration?param=${payload}`);
const getmoduleDataedit = () => instance.get("/ships/viewModulereport");


const getTableDataFromTablename = (tablename, type = "", page = { page: 1 }, imo_number = "") => {
  const pageNumber = page?.page || 1;
  return instance.get(
    `/ships/getTableRecords/${tablename}/${type}?page=${pageNumber}?imo_number=${imo_number}`
  );
};
const postFeeback = (payload) => instance.post(`/ratings`, payload);
const getAllFeeback = () => instance.get(`/ratings`);
const getAllFeebackStat = () => instance.get(`/ratings/stats`);


const inspectionService = {getshipById,
  getAllinspectionTimestamp, postFeeback, getAllFeeback, getAllFeebackStat,
  getshipspecificformConfiguration, getmoduleDataedit, getTableDataFromTablename,
  getModulesforUser, insertInspectionReport, updateFormConfiguration, getEventsByReport
}
export default inspectionService;


